<p-card header="Running Bet Amounts">
  <div class="grid">
    <div class="col-3">
      <label
        htmlFor="code"
        style="font-size: large; font-weight: bold; margin-right: 1rem"
        >Games :
      </label>
      <p-dropdown
        [style]="{ width: '100%' }"
        optionLabel="value"
        optionValue="value"
        [options]="games"
        [(ngModel)]="selectedgames"
        (onChange)="LoadRunninnBets()"
      ></p-dropdown>
    </div>
    <div class="col-3">
      <label
        htmlFor="code"
        style="font-size: large; font-weight: bold; margin-right: 1rem"
        >Time :
      </label>
      <p-dropdown
        [style]="{ width: '100%' }"
        optionLabel="value"
        optionValue="value"
        [options]="drawtime"
        [(ngModel)]="selecteddrawtime"
        (onChange)="LoadRunninnBets()"
      ></p-dropdown>
    </div>
    <div class="col-3">
      <label htmlFor="code" style="font-size: large; font-weight: bold; margin-right: 1rem"
        >Operator:
      </label>
      <p-dropdown
        [style]="{ width: '80%' }"
        optionLabel="value"
        optionValue="value"
        [options]="group"
        [(ngModel)]="selectedgroup"
        (onChange)="LoadRunninnBets()"
      ></p-dropdown>
    </div>
    <div class="col-3">
      <label
        htmlFor="code"
        style="font-size: large; font-weight: bold; margin-right: 1rem"
        >TOTAL GROSS
      </label>
      <h3>{{ GROSS }}</h3>
    </div>
  </div>

  <p-tabView class="p3">
    <p-tabPanel>
      <ng-template pTemplate="header">
        <span style="font-size: larger">BETS</span>
      </ng-template>
      <label
        htmlFor="code"
        style="font-size: large; font-weight: bold; margin-right: 1rem"
        class="mb-2"
        >
        <!-- STL RUNNING BETS -->
      </label>
      <div class="card">
        <p-table
          [value]="totalbets"
          [tableStyle]="{ 'min-width': '50rem' }"
          [paginator]="true"
          [rows]="10"
          [rowsPerPageOptions]="[10, 25, 50, 100, 1000, 10000]"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        >
          <ng-template pTemplate="caption">
            <div class="flex">
              <button
                type="button"
                pButton
                pRipple
                icon="pi pi-file-excel"
                (click)="exportExcel()"
                class="p-button-success mr-2"
                pTooltip="XLS"
                tooltipPosition="bottom"
              ></button>
            </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th>Game</th>
              <th>Time</th>
              <th>Combinations</th>
              <th>Total</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-totalbet>
            <tr>
              <td>{{ totalbet.drawtype }}</td>
              <td>{{ totalbet.drawtime }}</td>
              <td>{{ totalbet.combination }}</td>
              <td>{{ totalbet.total }}</td>
              <!-- <td>
              <p-button
                class="mx-1"
                icon="pi pi-user-edit"
                styleClass="p-button-rounded p-button-warning"
              ></p-button>
              <p-button
                icon="pi pi-trash"
                styleClass="p-button-rounded p-button-danger"
              ></p-button>
            </td> -->
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="5">No data found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-tabPanel>

    <!-- <p-tabPanel [selected]="true">
      <ng-template pTemplate="header">
        <span style="font-size: larger">3D / 2D</span>
      </ng-template>
      <label
        htmlFor="code"
        style="font-size: large; font-weight: bold; margin-right: 1rem"
        class="mb-2"
        >2D / 3D RUNNING BETS
      </label>
      <div class="card">
        <p-table
          [value]="totalbets"
          [tableStyle]="{ 'min-width': '50rem' }"
          [paginator]="true"
          [rows]="10"
          [rowsPerPageOptions]="[10, 25, 50, 100, 1000, 10000]"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        >
          <ng-template pTemplate="caption">
            <div class="flex">
              <button
                type="button"
                pButton
                pRipple
                icon="pi pi-file-excel"
                (click)="exportExcel()"
                class="p-button-success mr-2"
                pTooltip="XLS"
                tooltipPosition="bottom"
              ></button>
            </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th>Game</th>
              <th>Combinations</th>
              <th>Total</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-totalbet>
            <tr>
              <td>{{ totalbet.drawtype }}</td>
              <td>{{ totalbet.combination }}</td>
              <td>{{ totalbet.total }}</td>
              <td>
            <p-button
              class="mx-1"
              icon="pi pi-user-edit"
              styleClass="p-button-rounded p-button-warning"
            ></p-button>
            <p-button
              icon="pi pi-trash"
              styleClass="p-button-rounded p-button-danger"
            ></p-button>
          </td> 
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="5">No data found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-tabPanel> -->
  </p-tabView>
</p-card>

<p-dialog header="ADD" [(visible)]="visible" [style]="{ width: '50vw' }">
  <div class="grid">
    <div class="col-6">
      <div class="flex flex-column gap-2">
        <label htmlFor="code">Code</label>
        <input
          pInputText
          id="code"
          aria-describedby="code-help"
          [(ngModel)]="Code"
        />
      </div>
    </div>
    <div class="col-6">
      <div class="flex flex-column gap-2">
        <label htmlFor="name">Name</label>
        <input
          pInputText
          id="name"
          aria-describedby="name-help"
          [(ngModel)]="Name"
        />
      </div>
    </div>
    <!-- <div class="col-4">
        <div class="flex flex-column gap-2">
          <label htmlFor="">Lastname</label>
          <input
            pInputText
            id="lastname"
            aria-describedby="username-help"
            [(ngModel)]="value"
          />
        </div>
      </div> -->
  </div>
  <div class="flex flex-row-reverse flex-wrap">
    <button
      pButton
      pRipple
      label="SAVE"
      class="p-button-info mt-3 ml-2"
    ></button>
  </div>
</p-dialog>
